import { render } from "./PhotosShow.vue?vue&type=template&id=41c8effd"
import script from "./PhotosShow.vue?vue&type=script&lang=js"
export * from "./PhotosShow.vue?vue&type=script&lang=js"

import "./PhotosShow.vue?vue&type=style&index=0&id=41c8effd&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__